import {
  ApolloClient,
  createHttpLink,
  defaultDataIdFromObject,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import auth from '../../components/auth';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_API_URL,
  headers: {
    'X-client-name': 'admin-panel-apollo',
  },
});

const authLink = setContext((req, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = auth.getToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      'X-graphql-operation': req.operationName,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const cache = new InMemoryCache({
  dataIdFromObject(responseObject) {
    switch (responseObject.__typename) {
      case 'CRMUser':
        return (
          responseObject.id +
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (responseObject.subscription as any)?.id +
          responseObject.leadId
        );
      default:
        return defaultDataIdFromObject(responseObject);
    }
  },
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});
